import * as Sentry from "@sentry/nextjs";
import dayjs from 'dayjs';
import minMax from "dayjs/plugin/minMax";
import { addOfferToBooking } from '../../../app/api/postBooking';
import { BaseAction } from "../../../core/actions/BaseAction";
import { IAddShuttleOfferActionParams } from '../../../Orchestrator/Types/Interface/ActionParams/UpcomingPastBookingActionParams';

dayjs.extend(minMax);

class AddShuttleToBookOffersAction extends BaseAction<{ result: string, data: any }, IAddShuttleOfferActionParams> {

    override async run(): Promise<{ result: string, data: any }> {
        try {
            const { bookingId, passengers, offerId } = this.params!;
            let data;
            if (bookingId) {
                const offerIds = Array.isArray(offerId) ? offerId : [offerId];
                const passengerRefs = passengers.map((passenger: any) => passenger.externalRef);

                const payload = {
                    offers: offerIds.map((id: string) => ({
                        offerId: id,
                        passengerRefs: passengerRefs
                    }))
                }
                const response: any = await addOfferToBooking(bookingId, payload);
                if (response.status === "ok" && response.answer) {
                    data = response.answer;
                } else {
                    Sentry.captureMessage("AddShuttleToBookOffersAction: add rejected", {
                        level: "warning",
                        tags: { action: "AddShuttleToBookOffersAction" },
                        extra: { bookingId, offerId, response },
                    });
                    return { result: "false", data: response };
                }
            }
            let responseData = {
                result: "true",
                data: data
            }
            return responseData;
        } catch (error: any) {
            console.error("Error fetching offers:", error);
            Sentry.captureException(error, {
                tags: { action: "AddShuttleToBookOffersAction" },
                extra: { bookingId: this.params?.bookingId, offerId: this.params?.offerId },
            });
            let responseData = {
                result: "false",
                data: []
            }
            return responseData;
        }
    }
}

export const addShuttleToBookOffersAction = new AddShuttleToBookOffersAction()


